import {
  SET_CARE_TEAM_DATA,
  TOGGLE_CARE_TEAM_LIST_MODAL,
  RESET_CARE_TEAM_DATA,
  TOGGLE_CARE_TEAM_DATA_LOADING,
  SET_SELECTED_CARE_TEAM_DATA,
} from 'redux/actions/actionTypes';

const initialState = {
  careTeamList: [],
  showCareTeamListModal: false,
  isLoading: false,
  selectedForConsult: null,
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_CARE_TEAM_DATA: {
      const careTeamList = payload?.careTeamList || [];
      const isLoading = payload?.isLoading || false;
      return {
        ...state,
        careTeamList,
        isLoading,
      };
    }

    case TOGGLE_CARE_TEAM_DATA_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case RESET_CARE_TEAM_DATA: {
      return {
        ...initialState,
      };
    }

    case TOGGLE_CARE_TEAM_LIST_MODAL: {
      return {
        ...state,
        showCareTeamListModal: payload,
      };
    }

    case SET_SELECTED_CARE_TEAM_DATA: {
      return {
        ...state,
        selectedForConsult: payload,
      };
    }

    default:
      return state;
  }
};
